import clsx from 'clsx';

export function TruckIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 19"
      className={className}
    >
      <path
        fill="#02C874"
        stroke="white"
        strokeLinejoin="round"
        d="M1 1h12v13H1zM13 5h3.43L19 8.38V14h-6V5Z"
      />
      <path
        fill="#02C874"
        stroke="white"
        strokeLinejoin="round"
        d="M13 9h6v5h-6V9Z"
      />
      <circle cx="4.2" cy="15.8" r="1.8" fill="#02C874" stroke="white" />
      <circle cx="15" cy="15.8" r="1.8" fill="#02C874" stroke="white" />
    </svg>
  );
}

export function ReturnsIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 24"
      className={className}
    >
      <circle cx="10.06" cy="10.92" r="9.56" fill="#02C874" stroke="white" />
      <path
        stroke="white"
        strokeLinecap="round"
        d="M14.78 7.78a5.75 5.75 0 1 1-4.15-2.43"
      />
      <path
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m9.05 3.5 2.03 1.86-1.86 2.03"
      />
    </svg>
  );
}

export function DollarIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={clsx(className, 'text-green-500')}
    >
      <path d="M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z" />
      <path
        fillRule="evenodd"
        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
